import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../../core/auth/auth.service';
import { PatientSelectionComponent } from '../../../../../../../../src/app/patient-selection/patient-selection.component';
import { ShareService } from '../../../../../../../app/shared/service/share.service';
import { FeatureAccessService } from '../../../../../../shared/service/feature-access.service';
import { StorageService } from '../../../../../../Service/storage.service';
import { MyProfileService } from '../my-profile/my-profile.service';
import { CommonResolverService } from '../../../../../../common-layout/common-resolver.service';
import { UserProfileService } from './user-profile.service';

@Component({
    selector: 'kt-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  @Input() showHi: boolean = true;
  user: any
  userId: any;
  patientList: any;
  @ViewChild("MyProfilefile", { static: true }) MyProfilefile: ElementRef;
  isAdminLogin: boolean = false;;
  isAdmin: boolean;
  progressPercent = 0;
  profilePhoto: string | null = null;

  activeMenu:
    | 'my-profile'
    | 'communication-preferences'
    | 'account-overview'
    | 'language'
    | 'change-password'
    | 'sign-out'
    | null = null;

  get progressDegree() {
    return this.progressPercent * 3.6;
  }
  get progressColor() {
    return '#044b4f';
  }

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly shareService: ShareService,
    public dialog: MatDialog,
    public toastr: ToastrService,
    public featureAccessService: FeatureAccessService,
    private readonly storageService: StorageService,
    private readonly myProfileService: MyProfileService,
    public commonResolverService: CommonResolverService,
    private readonly userProfileService: UserProfileService
  ) {
    this.isAdmin = this.storageService.getItem("IsAdmin") == "true";
    const role = (this.storageService.getItem('AspNetRole') ?? '').toLowerCase();
    this.isAdminLogin = role.includes('admin');
    this.userId = this.storageService.getItem('userId');
  }

  ngOnInit(): void {
    this.user = this.storageService.getItem('Name');
    this.userId = this.storageService.getItem('userId');
    if (sessionStorage.getItem("PatientList")) {
      this.patientList = JSON.parse(sessionStorage.getItem("PatientList"));
    }
    if (!this.authService.isInOnboarding()) {
      this.myProfileService.loadPercentageFromDBOnce();
    }
    this.myProfileService.steps$.subscribe(() => {
      this.progressPercent = this.myProfileService.getProgressPercentage();
    });

    if (!this.authService.isInOnboarding()) {
      this.GetProfileImage();
    }
    this.userProfileService.isUserProfileChange.subscribe(res => {
      if (res) {
        this.GetProfileImage();
        this.user = this.storageService.getItem('Name');
      }
    });

    const url = this.router.url || '';
    if (url.includes('/communication-preferences')) {
      this.activeMenu = 'communication-preferences';
    } else if (url.startsWith('/my-profile')) {
      this.activeMenu = 'my-profile';
    } else if (url.startsWith('/account-overview')) {
      this.activeMenu = 'account-overview';
    } else {
      this.activeMenu = null;
    }
  }

  GetProfileImage() {
    if (!this.userId) {
      this.profilePhoto = null;
      return;
    }
    this.userProfileService.getUserDetailById(this.userId, false).subscribe(response => {
      const data = response["Data"];
      const base64 = data?.ProfilePicture;
      if (!base64) {
        this.profilePhoto = null;
        return;
      }
      const mime = this.detectAllowedImageType(base64);
      if (!mime) {
        this.profilePhoto = null;
        return;
      }
      this.profilePhoto = `data:${mime};base64,${base64}`;
    });
  }

  detectAllowedImageType(base64: string): string | null {
    try {
      const bytes = atob(base64).slice(0, 4).split('').map(c => c.charCodeAt(0));
      if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) {
        return 'image/png';
      }
      if (bytes[0] === 0xFF && bytes[1] === 0xD8) {
        return 'image/jpeg';
      }
    } catch (e) {
      console.error('Error decoding base64 image', e);
    }
    return null;
  }

  openPatientList() {
    this.dialog.open(PatientSelectionComponent, {
      data: { patientList: this.patientList, fromLoggedInUser: true },
      disableClose: true,

    }).afterClosed().subscribe(() => {
      this.user = this.storageService.getItem('Name');
      this.userId = this.storageService.getItem('userId');
      this.shareService.editUserId(this.userId);
    });
  }
  openChangePasswordDialog() {
    this.activeMenu = 'change-password';
    let data = {
      componentName: 'userProfile',
      userName: this.authService.userName
    }
    this.storageService.setItem('changePasswordData', JSON.stringify(data));
    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
      autoFocus: false,
      data,
      panelClass: 'popup_custom_width_small'
    });
  }
  openMyProfile() {
    this.activeMenu = 'my-profile';
    this.router.navigate(['/my-profile']);
  }
  openAccountOverviewDialog() {
    this.activeMenu = 'account-overview';
    this.router.navigate(['/account-overview']);
  }
  openCommunicationPreferences() {
    this.activeMenu = 'communication-preferences';
    this.router.navigate(['/communication-preferences']);
  }
  logout() {
    this.activeMenu = 'sign-out';
    this.authService.logout();
  }

  get truncatedUser(): string {
    if (!this.user) return '';
    return this.user.length > 25 ? this.user.substring(0, 25) + '...' : this.user;
  }
}
